import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjPreference2"
});
const _hoisted_1 = {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M10.8993 2.23271H3.49956C3.49956 3.15456 3.49977 6.28809 3.49977 6.61947L3.49964 9.93454C3.49964 10.2659 3.49886 13.9811 3.49905 14.233C3.49905 14.233 12.5346 14.233 12.88 14.233C13.2254 14.233 13.0492 14.233 13.5054 14.233L13.5054 2.23162C13.196 2.23077 11.2447 2.23271 10.8993 2.23271Z",
  stroke: "#5587FF",
  "stroke-width": "1.3",
  "stroke-linecap": "square",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.60156 9.18818C5.60156 9.0225 5.73588 8.88818 5.90156 8.88818H11.1017C11.2674 8.88818 11.4017 9.0225 11.4017 9.18818V9.93525C11.4017 10.1009 11.2674 10.2353 11.1017 10.2353H5.90156C5.73588 10.2353 5.60156 10.1009 5.60156 9.93525V9.18818Z",
  fill: "#7FA5FF"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.60156 11.4587C5.60156 11.293 5.73588 11.1587 5.90156 11.1587H9.00162C9.1673 11.1587 9.30162 11.293 9.30162 11.4587V12.2019C9.30162 12.3675 9.1673 12.5019 9.00162 12.5019H5.90156C5.73588 12.5019 5.60156 12.3675 5.60156 12.2019V11.4587Z",
  fill: "#7FA5FF"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.0796 4.57616C11.2749 4.77142 11.2749 5.088 11.0796 5.28326L8.4674 7.89546C8.15498 8.20788 7.64845 8.20788 7.33603 7.89546L5.92387 6.4833C5.7286 6.28803 5.7286 5.97145 5.92387 5.77619L6.34813 5.35193C6.54339 5.15666 6.85997 5.15666 7.05524 5.35193L7.90172 6.1984L9.94823 4.15189C10.1435 3.95663 10.4601 3.95663 10.6553 4.15189L11.0796 4.57616Z",
  fill: "#7FA5FF"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var SJ_preference_2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_preference_2 as default };
